/**
 * Shadow Design Tokens
 *
 * ⭐ MODIFY SHADOWS HERE
 * Change these values to update the entire app's shadows
 */

export const shadows = {
  sm: '0 1px 2px 0 rgba(0, 0, 0, 0.3)',
  md: '0 4px 6px -1px rgba(0, 0, 0, 0.3)',
  lg: '0 10px 15px -3px rgba(0, 0, 0, 0.3)',
  xl: '0 20px 25px -5px rgba(0, 0, 0, 0.3)',

  // Product card shadow (changes on hover)
  card: {
    default: '0 4px 6px rgba(0, 0, 0, 0.2)',
    hover: '0 12px 24px rgba(0, 0, 0, 0.3)',   // CHANGE ME
  },

  // Ambient glow for dark theme
  glow: {
    brand: '0 0 20px rgba(99, 102, 241, 0.2)',   // Blue glow
    accent: '0 0 20px rgba(255, 107, 53, 0.2)',  // Orange glow
  },
} as const;
